<template>
<div class="shadow-box">
  <div class="h3-title flex-row flex-main-axis-between" style="margin-top: 0; margin-right: 0;">
    <span>下游账号设置</span>
    <span class="header-actions flex-row flex-secondary-axis-center">
      <span class="commission-rate-info">
        <b>折扣点：</b>{{ commissionRateLabel }}
        <i class="el-icon-edit edit-icon" @click="handleEditCommissionRate"></i>
      </span>
      <el-button
        icon="el-icon-copy-document"
        v-clipboard:copy="inviteRegisterLink"
        v-clipboard:success="() => $message.success('复制成功')"
      >复制邀请注册链接</el-button>
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd">新增</el-button>
    </span>
  </div>
  <el-dialog
    :visible.sync="showCommissionRateDialog"
    title="修改折扣点"
    width="520px"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form label-width="80px">
      <el-form-item label="折扣点">
        <el-input
          v-model="commissionRateForm.xyCommissionRate"
          placeholder="请输入折扣点，如3表示3%"
          @input="validateCommissionRateInput"
        >
          <template slot="append">%</template>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="showCommissionRateDialog = false">取消</el-button>
      <el-button type="primary" :loading="commissionRateSaving" @click="saveCommissionRate">保存</el-button>
    </div>
  </el-dialog>
  <div class="page-main_box">
    <div class="flex-row search-box">
      <div class="search-item">
        <div class="label">账号：</div>
        <el-input v-model="form.mobilePhone" @blur="getList" @clear="getList" clearable placeholder="请输入下游账号手机"></el-input>
      </div>
      <div class="search-item">
        <div class="label">昵称：</div>
        <el-input v-model="form.nickName" @blur="getList" @clear="getList" clearable placeholder="请输入下游账号昵称"></el-input>
      </div>
      <div class="search-item">
        <div class="label">角色：</div>
        <el-select v-model="form.roleName" @blur="getList" @clear="getList" clearable placeholder="请选择角色">
          <el-option v-for="(item, index) in roles" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="search-item">
        <div class="label">渠道固定扣点：</div>
        <el-input v-model="form.channelDeduction" @blur="getList" @clear="getList" clearable placeholder="请输入渠道固定扣点"></el-input>
      </div>
      <div class="search-item">
        <div class="label">状态：</div>
        <el-select clearable v-model="form.status" @change="getList" placeholder="选择状态">
          <el-option :value="''" label="全部"></el-option>
          <el-option :value="1" label="开启"></el-option>
          <el-option :value="0" label="关闭"></el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="getList">查 询</el-button>
    </div>
    <div class="code-list-content">
      <!--  昵称     创建日期 操作 -->
      <el-table
        row-key="id"
        border
        stripe
        default-expand-all
        style="width: calc(100vw - 280px);"
        height="calc(100vh - 260px)"
        :data="tableData"
        v-loading="isLoading" >
        <el-table-column
          prop="mobilePhone"
          fixed
          label="账号"
          min-width="120">
        </el-table-column>
        <el-table-column
          prop="nickName"
          label="昵称"
          min-width="120"> 
        </el-table-column>
        <el-table-column
          prop="roleName"
          label="角色"
          min-width="120"> 
        </el-table-column>
        <el-table-column
          min-width="140"
          label="渠道固定扣点（%）">
          <template slot="header" slot-scope="scope">
            <div>渠道固定扣点(%)
               <el-tooltip class="item" effect="dark" placement="top">
                <template slot="content">
                  设置后，该账号在选品库看到的佣金比例会自<br />动比渠道少几个点，并且报单后会按此结算
                </template>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="{ row }">
            <div v-if="row.userPromotion && row.userPromotion.channelDeduction">
              {{ (row.userPromotion.channelDeduction / 1000).toFixed(2) + '%' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          show-overflow-tooltip
          min-width="140">
          <template slot-scope="{ row }">
            <el-switch :value="row.status"
              active-color="#0076F6"
              inactive-color="#f4f5f7"
              @change="e => flagChange(e, row)"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建日期"
          show-overflow-tooltip
          min-width="160">
          <template slot-scope="{ row }">
            <div>
              {{ row.createTime | filterDate }}
            </div>
          </template>
        </el-table-column> 
        <el-table-column
          fixed="right"
          label="操作"
          width="260">
          <template slot-scope="{ row }">
            <div>
              <el-button type="text" @click="editHander(row)">编辑</el-button>
              <el-button type="text"
                v-clipboard:copy="row.cOrderLink"
                v-clipboard:success="() => $message.success('复制成功')">复制移动端报单链接</el-button> 
              <el-button type="text" @click="showHistoryList(row)">查看历史记录</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="bd--pag">
        <el-pagination
          class="d-ib"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          :page-sizes="pageInfo.sizes"
          :page-size="pageInfo.size"
          :current-page="pageInfo.current"
          @current-change="pageInfo.current = arguments[ 0 ], getList()"
          @size-change="pageInfo.size = arguments[ 0 ], getList()">
        </el-pagination>
      </div> 
    </div>
  </div>

  <!-- 新增/修改 -->
  <createDrawer
    v-if="showCreateDrawer"
    v-model="showCreateDrawer"
    :editRow="editRow"
    :parentDepart="parentDepart"
    @close="showCreateDrawer = false"
    @on-success="successHandler"
  ></createDrawer>

  <historyListDialog
    v-if="showHistoryDialog"
    v-model="showHistoryDialog"
    :row="editRow"
    @close="showHistoryDialog = false"
  />

</div>
</template>
<script>
import createDrawer from '@/page/component/sections/downstream/account-drawer'
import { getBdDownStreamAccountList, updateStatus } from '@/service/apis/streamAccount'
import { getBdDownStreamCommissionRate, saveBdDownStreamCommissionRate } from '@/service/apis/mall'
import historyListDialog from '../../../../sections/downstream/history-list-dialog.vue'
import { getRoletype, getUserId } from '@/utils/getUser'
import NP from 'number-precision'
const dayjs = require('dayjs')
const inviteRegisterBaseLink = 'https://xp.bpsheab.com/#/pages/login/register?type=downstream&qdAccountId='
// const baseLink = location.protocol + '//' + domain + '/#/?qdAccountId='
const baseLink = 'https://bd.jwhdz.com/#/?qdAccountId='

export default {
  components: { 
    createDrawer,
    historyListDialog
   },
   computed: {
    roleType () {
      return getRoletype()
    },
    commissionRateLabel () {
      const rate = this.commissionRateInfo && this.commissionRateInfo.xyCommissionRate
      if (this.hasCustomCommissionRate) {
        return `${(Number(rate) / 100).toFixed(2)}%`
      }
      return '默认3%'
    },
    hasCustomCommissionRate () {
      const rate = this.commissionRateInfo && this.commissionRateInfo.xyCommissionRate
      return rate != null && rate !== '' && !isNaN(Number(rate))
    },
    inviteRegisterLink () {
      return `${inviteRegisterBaseLink}${getUserId()}`
    }
   },
  data () {
    return {
      roles: [{
        name: '代理',
        value: '代理'
      }, {
        name: '同行',
        value: '同行'
      }, {
        name: '散客',
        value: '散客'
      }],
      form: {
        channelDeduction: '',
        roleName: '',
        nickName: '',
        mobilePhone: '',
        status: ''
      },
      pageInfo: {
        current: 1,
        size: 10,
        sizes: [ 10, 20, 30, 50, 100 ],
        pages: 0,
        total: 0
      },
      isLoading: false,
      tableData: [],
      editRow: null,
      parentDepart: null,
      showCreateDrawer: false,
      showHistoryDialog: false,
      showCommissionRateDialog: false,
      commissionRateSaving: false,
      commissionRateInfo: null,
      commissionRateForm: {
        xyCommissionRate: ''
      }
    }
  },
  filters: {
    filterDate (date) {
      if (date) {
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
      }
      return ''
    }
  },
  created () {
    this.$nextTick(() => {
      this.getList()
      this.fetchCommissionRate()
    })
  },
  methods: {
    handleAdd () {
      this.editRow = null
      this.parentDepart = null
      this.showCreateDrawer = true
    },
    fetchCommissionRate () {
      getBdDownStreamCommissionRate.call(this).then(res => {
        const rate = res && res.xyCommissionRate
        if (rate != null && rate !== '' && !isNaN(Number(rate))) {
          this.commissionRateInfo = res
        } else {
          this.commissionRateInfo = null
        }
      }).catch(() => {
        this.commissionRateInfo = null
      })
    },
    handleEditCommissionRate () {
      if (this.hasCustomCommissionRate) {
        this.commissionRateForm.xyCommissionRate = String(Number(this.commissionRateInfo.xyCommissionRate) / 100)
      } else {
        this.commissionRateForm.xyCommissionRate = ''
      }
      this.showCommissionRateDialog = true
    },
    validateCommissionRateInput (value) {
      this.commissionRateForm.xyCommissionRate = value
        .replace(/[^\d.]/g, '')
        .replace(/\.{2,}/g, '.')
        .replace(/^(\d+\.?\d{0,2}).*$/, '$1')
        .replace(/^(\d+\.?\d*)(.*)$/, '$1')
    },
    saveCommissionRate () {
      const val = this.commissionRateForm.xyCommissionRate
      if (val === '' || val == null) {
        this.$message.error('请输入折扣点')
        return
      }
      if (isNaN(Number(val))) {
        this.$message.error('请输入有效的折扣点')
        return
      }
      this.commissionRateSaving = true
      saveBdDownStreamCommissionRate.call(this, {
        xyCommissionRate: NP.times(val, 100)
      }).then(() => {
        this.$message.success('保存成功')
        this.showCommissionRateDialog = false
        this.fetchCommissionRate()
      }).finally(() => {
        this.commissionRateSaving = false
      })
    },
    showHistoryList (row) {
      this.editRow = row
      this.showHistoryDialog = true
    },
    editHander (row) {
      this.editRow = row
      this.showCreateDrawer = true
    },
    flagChange (e, row) {
      const loading = this.$loading({
        lock: true,
        text: '更新中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      updateStatus.call(this, {
        // ...row,
        id: row.id,
        status: e
      }).then(res => {
        this.getList()
        this.$message.success('更新状态成功')
      }).finally(() => {
        loading.close()
      })
    },
    getList () { 
      this.isLoading = true
      this.tableData = []
      let formOpt = JSON.parse(JSON.stringify(this.form))
      let opt = {}
      for (let key in formOpt) {
        if (formOpt[key] !== '' && formOpt[key] !== null && formOpt[key] !== undefined) {
          opt[key] = formOpt[key]
        }
      }
      if (opt.channelDeduction && !isNaN(Number(opt.channelDeduction))) {
        opt.channelDeduction = Number(opt.channelDeduction) * 1000
      } else if (opt.channelDeduction && isNaN(Number(opt.channelDeduction))) {
        opt.channelDeduction = -999
      }
      getBdDownStreamAccountList.call(this, {
        ...opt,
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size
      }).then((res) => {
        const {records, pages, total} = res
        this.pageInfo.total = total || 0
        this.pageInfo.pages = pages || 0
        this.tableData = [...(records || [])].map(item => {
          return {
            ...item,
            cOrderLink: `${baseLink}${item.accountId}`
          }
        })
      }).finally(() => {
        this.isLoading = false
      })
    },
    // 新增、修改回调
    successHandler () {
      this.showCreateDrawer = false
      this.getList()
    }
  }
}
</script>
<style scoped>
.link {
  padding-left: 24px;
  font-size: 14px;
}
.shadow-box {
  padding: 12px 24px 16px 24px;
}
.header-actions .el-button + .el-button {
  margin-left: 12px;
}
.commission-rate-info {
  margin-right: 16px;
  font-size: 14px;
  color: #333;
}
.edit-icon {
  margin-left: 4px;
  color: #0076F6;
  cursor: pointer;
  font-size: 14px;
}
</style>
